import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../redux-toolkit/hooks";
import * as Yup from 'yup';
import { Modal } from "react-bootstrap";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useBulkSaveOpportunityTypeMutation, useFindAllOpportunityTypeMutation, useGetOpportunityTypeByIdMutation, useSaveOpportunityTypeMutation, useUpdateOpportunityTypeMutation } from "../../redux-toolkit/services/opportunityTypeService";
import { useBulkSaveOpportunityMasterMutation, useFindAllOpportunityMasterMutation, useGetOpportunityMasterByIdMutation, useSaveOpportunityMasterMutation, useUpdateOpportunityMasterMutation } from "../../redux-toolkit/services/opportunityMasterService";
import { allOpportunityMasterDetails, getAllOpportunityMasterBySearch, getOpportunityMasterDetails, getOpportunityMasterTotalRecords, setAllOpportunityMaster } from "../../redux-toolkit/slices/opportunityMasterSlice";
import { allOpportunityTypeDetails, getAllOpportunityTypeBySearch, getOpportunityTypeDetails, getOpportunityTypeTotalRecords, setAllOpportunityType } from "../../redux-toolkit/slices/opportunityTypeSlice";
import { useFindAllInvestmentMandateTypeMutation } from "../../redux-toolkit/services/investmentMandateTypeService";
import { allInvestmentMandateTypeDetails, setAllInvestmentMandateType } from "../../redux-toolkit/slices/investmentMandateTypeSlice";
import { useFindAllAssetsMutation } from "../../redux-toolkit/services/assetsService";
import { useFindAllEntityMasterMutation } from "../../redux-toolkit/services/entityMasterService";
import { allEntityMasterDetails, setAllEntityMaster } from "../../redux-toolkit/slices/entityMasterSlice";
import { allAssetsDetails, setAllAssets } from "../../redux-toolkit/slices/assetsSlice";
import { format, parseISO } from "date-fns";
import { useFindAllAssetTypeMutation } from "../../redux-toolkit/services/assetTypeService";
import { allAssetTypeDetails, setAllAssetType } from "../../redux-toolkit/slices/assetTypeSlice";
import { useAddToAuditMutation, useAddToFinanceMutation, useAddToProjectMutation, useBulkSaveOpportunityApplicationMutation, useFindAllOpportunityApplicationMutation, useGetOpportunityApplicationByIdMutation, useGetOpportunityDueDiligenceMutation, useSaveOpportunityApplicationMutation, useUpdateOpportunityApplicationMutation } from "../../redux-toolkit/services/opportunityApplicationService";
import { useBulkSaveOpportunityAllocationMutation, useGetOpportunityAllocationByIdMutation, useSaveOpportunityAllocationMutation, useUpdateOpportunityAllocationMutation } from "../../redux-toolkit/services/opportunityAllocationService";
import { useBulkSaveMemberInterviewRecordMutation, useFindAllMemberInterviewRecordMutation, useGetMemberInterviewRecordByIdMutation, useSaveMemberInterviewRecordMutation, useUpdateMemberInterviewRecordMutation } from "../../redux-toolkit/services/memberInterviewRecordService";
import { allEntityTypeMasterDetails, setAllEntityTypeMaster } from "../../redux-toolkit/slices/entityTypeMasterSlice";
import { allMemberInterviewRecordDetails, setAllMemberInterviewRecord } from "../../redux-toolkit/slices/memberInterviewRecordSlice";
import { useFindAllEntityTypeMasterMutation } from "../../redux-toolkit/services/entityTypeMasterService";
import { useBulkSaveOpportunityApplicationInterviewMutation, useGetOpportunityApplicationInterviewByIdMutation, useSaveOpportunityApplicationInterviewMutation, useUpdateOpportunityApplicationInterviewMutation } from "../../redux-toolkit/services/opportunityApplicationInterviewService";
import { setAllOpportunityApplication } from "../../redux-toolkit/slices/opportunityApplicationSlice";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
    isCategory?: boolean;
    setIsCategory?: any;
};

const validationSchema = Yup.object().shape({
    percentageCompleted: Yup.number()
        .min(0, 'Percentage must be at least 0')
        .max(100, 'Percentage cannot exceed 100'),
});

const OpportunityData = (props: Props) => {

    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    const setFieldValueRef = useRef<any>(null);
    const formikValuesRef = useRef<any>(null);
    const prevAssetTypeRef = useRef<any>(null);

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [selectData, setSelectData]: any = useState();
    const [fileName, setFileName] = useState("");

    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");

    //save
    const [saveOpportunityType, saveOpportunityTypeResponse] = useSaveOpportunityTypeMutation();
    const [saveOpportunityMaster, saveOpportunityMasterResponse] = useSaveOpportunityMasterMutation();
    const [saveOpportunityApplication, saveOpportunityApplicationResponse] = useSaveOpportunityApplicationMutation();
    const [saveOpportunityApplicationInterview, saveOpportunityApplicationInterviewResponse] = useSaveOpportunityApplicationInterviewMutation();
    const [saveOpportunityAllocation, saveOpportunityAllocationResponse] = useSaveOpportunityAllocationMutation();
    const [saveMemberInterviewRecord, saveMemberInterviewRecordResponse] = useSaveMemberInterviewRecordMutation();

    //bulk
    const [bulkSaveOpportunityType, bulkSaveOpportunityTypeResponse] = useBulkSaveOpportunityTypeMutation();
    const [bulkSaveOpportunityMaster, bulkSaveOpportunityMasterResponse] = useBulkSaveOpportunityMasterMutation();
    const [bulkSaveOpportunityApplication, bulkSaveOpportunityApplicationResponse] = useBulkSaveOpportunityApplicationMutation();
    const [bulkSaveOpportunityApplicationInterview, bulkSaveOpportunityApplicationInterviewResponse] = useBulkSaveOpportunityApplicationInterviewMutation();
    const [bulkSaveOpportunityAllocation, bulkSaveOpportunityAllocationResponse] = useBulkSaveOpportunityAllocationMutation();
    const [bulkSaveMemberInterviewRecord, bulkSaveMemberInterviewRecordResponse] = useBulkSaveMemberInterviewRecordMutation();

    const [saveToProject, saveToProjectRes] = useAddToProjectMutation();
    const [saveToAudit, saveToAuditRes] = useAddToAuditMutation();
    const [saveToFinance, saveToFinanceRes] = useAddToFinanceMutation();

    //update
    const [updateOpportunityType, updateOpportunityTypeResponse] = useUpdateOpportunityTypeMutation();
    const [updateOpportunityMaster, updateOpportunityMasterResponse] = useUpdateOpportunityMasterMutation();
    const [updateOpportunityApplication, updateOpportunityApplicationResponse] = useUpdateOpportunityApplicationMutation();
    const [updateOpportunityApplicationInterview, updateOpportunityApplicationInterviewResponse] = useUpdateOpportunityApplicationInterviewMutation();
    const [updateOpportunityAllocation, updateOpportunityAllocationResponse] = useUpdateOpportunityAllocationMutation();
    const [updateMemberInterviewRecord, updateMemberInterviewRecordResponse] = useUpdateMemberInterviewRecordMutation();


    //getById mutation
    const [getOpportunityTypeById, opportunityTypeByIdResponse] = useGetOpportunityTypeByIdMutation();
    const [getOpportunityMasterById, opportunityMasterByIdResponse] = useGetOpportunityMasterByIdMutation();
    const [getOpportunityApplicationById, opportunityApplicationByIdResponse] = useGetOpportunityApplicationByIdMutation();
    const [getOpportunityApplicationInterviewById, opportunityApplicationInterviewByIdResponse] = useGetOpportunityApplicationInterviewByIdMutation();
    const [getOpportunityAllocationById, opportunityAllocationByIdResponse] = useGetOpportunityAllocationByIdMutation();
    const [getMemberInterviewRecordById, memberInterviewRecordByIdResponse] = useGetMemberInterviewRecordByIdMutation();

    const [getOpportunityDueDiligence, opportunityDueDiligenceRes] = useGetOpportunityDueDiligenceMutation();

    //getData
    const [findAllOpportunityType, findAllOpportunityTypeRes] = useFindAllOpportunityTypeMutation();
    const [findAllOpportunity, findAllOpportunityRes] = useFindAllOpportunityMasterMutation();
    const [findAllOpportunityApplication, findAllOpportunityApplicationRes] = useFindAllOpportunityApplicationMutation();
    const [findAllInvestmentMandateType, findAllInvestmentMandateTypeRes] = useFindAllInvestmentMandateTypeMutation();
    const [findAllAssets, findAllAssetsResponse] = useFindAllAssetsMutation();
    const [findAllAssetType, findAllAssetTypeResponse] = useFindAllAssetTypeMutation();
    const [findAllEntityMaster, findAllEntityMasterResponse] = useFindAllEntityMasterMutation();
    const [findAllEntityType, findAllEntityTypeResponse] = useFindAllEntityTypeMasterMutation();
    const [findAllMemberInterviewRecord, findAllMemberInterviewRecordResponse] = useFindAllMemberInterviewRecordMutation();

    //Data
    const allOpportuntiyTypeData: any = useAppSelector(allOpportunityTypeDetails);
    const allOpportuntiyData: any = useAppSelector(allOpportunityMasterDetails);
    const allInvestmentMandateTypeData: any = useAppSelector(allInvestmentMandateTypeDetails);
    const allEntityMasterData: any = useAppSelector(allEntityMasterDetails);
    const allEntityTypeData: any = useAppSelector(allEntityTypeMasterDetails);
    const allAssetsData: any = useAppSelector(allAssetsDetails);
    const allAssetTypeData: any = useAppSelector(allAssetTypeDetails);
    const allMemberInterviewRecords: any = useAppSelector(allMemberInterviewRecordDetails);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
                findAllInvestmentMandateType({ token: localUserObj?.token, });
                getOpportunityTypeById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
                findAllOpportunityType({ token: localUserObj?.token, });
                findAllAssets({ token: localUserObj?.token, });
                findAllAssetType({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                getOpportunityMasterById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
                findAllEntityType({ token: localUserObj?.token });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
                findAllOpportunityType({ token: localUserObj?.token, });
                findAllOpportunity({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                findAllEntityType({ token: localUserObj?.token, });

                getOpportunityApplicationById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
                findAllOpportunityType({ token: localUserObj?.token, });
                findAllOpportunityApplication({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                findAllEntityType({ token: localUserObj?.token, });

                getOpportunityApplicationInterviewById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
                findAllOpportunity({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                findAllEntityType({ token: localUserObj?.token, });
                findAllMemberInterviewRecord({ token: localUserObj?.token, });

                getOpportunityAllocationById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
                findAllOpportunityType({ token: localUserObj?.token, });
                findAllOpportunity({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                findAllEntityType({ token: localUserObj?.token, });

                getMemberInterviewRecordById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            }

        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
                findAllInvestmentMandateType({ token: localUserObj?.token, });

            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
                findAllAssetType({ token: localUserObj?.token, });
                findAllOpportunityType({ token: localUserObj?.token, });
                findAllAssets({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                findAllEntityType({ token: localUserObj?.token });

            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
                findAllOpportunityType({ token: localUserObj?.token, });
                findAllOpportunity({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                findAllEntityType({ token: localUserObj?.token, });

            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
                findAllOpportunityType({ token: localUserObj?.token, });
                findAllOpportunityApplication({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                findAllEntityType({ token: localUserObj?.token, });

            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
                findAllOpportunity({ token: localUserObj?.token, });
                findAllEntityMaster({ token: localUserObj?.token, });
                findAllEntityType({ token: localUserObj?.token, });
                findAllMemberInterviewRecord({ token: localUserObj?.token, });

            } else if (props.reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
                findAllOpportunityType({ token: localUserObj?.token, });
            }
        }
    }, [props.reportName]);

    const handleClose = () => {
        props.setShow(false);
    };

    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
                const payload = {
                    code: values.code,
                    name: values.name,
                    description: values.description,
                    opportunityProvider: values.opportunityProvider,
                    opportunityStartDate: values.opportunityStartDate,
                    opportunityEndDate: values.opportunityEndDate,
                    opportunityStatus: values.opportunityStatus,
                    opportunityTypeId: values.opportunityTypeId ? parseInt(values.opportunityTypeId) : null,
                    eventVenue: values.eventVenue,
                    eventType: values.eventType,
                    criteria: values.criteria,
                    assetTypeId: values.assetTypeId ? parseInt(values.assetTypeId) : null,
                    assetsId: values.assetsId ? parseInt(values.assetsId) : null,
                    quantity: values.quantity ? parseFloat(values.quantity) : null,
                    uom: values.uom,
                    referrerEntityId: values.referrerEntityId ? parseInt(values.referrerEntityId) : null,
                    remarks: values.remarks,
                    userId: localUserObj?.id,
                    entityTypeId: values.entityTypeId ? parseInt(values.entityTypeId) : null,
                    entityId: values.entityId ? parseInt(values.entityId) : null,
                    status: true
                };

                saveOpportunityMaster({
                    token: localUserObj?.token,
                    payload: payload,
                })

            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
                const payload = {
                    code: values.code,
                    name: values.name,
                    description: values.description,
                    // llmRequest: values.llmRequest,
                    // llmResponse: values.llmResponse,
                    // Convert comma-separated strings to arrays
                    sdgGoals: [values.sdgGoals],
                    investmentMandateTypeId: values.investmentMandateTypeId ? parseInt(values.investmentMandateTypeId) : null,
                    sector: [values.sector],
                    remarks: values.remarks,
                    status: true
                };

                saveOpportunityType({
                    token: localUserObj?.token,
                    payload: payload,
                })
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {

                const payload = {
                    name: values.name,
                    email: values.email,
                    phoneNumber: values.phoneNumber,
                    socialMediaUrl: values.socialMediaUrl,
                    code: values.code,
                    entityMasterId: values.entityMasterId ? parseInt(values.entityMasterId) : null,
                    entityTypeId: values.entityTypeId ? parseInt(values.entityTypeId) : null,
                    opportunityTypeId: values.opportunityTypeId ? parseInt(values.opportunityTypeId) : null,

                    source: values.source,
                    followupDetails: values.followupDetails,
                    followupDate: values.followupDate,
                    remark: values.remark,
                    opportunityId: values.opportunityId ? parseInt(values.opportunityId) : null,
                    financeTransactionCode: values.financeTransactionCode,

                    userId: localUserObj?.id,
                    shortListed: values.shortListed,
                    status: true
                };

                const formData = new FormData();
                formData.append('opportunityApplicationReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                saveOpportunityApplication({
                    token: localUserObj?.token,
                    payload: formData,
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {

                const payload = {
                    name: values.name,
                    email: values.email,
                    phoneNumber: values.phoneNumber,
                    socialMediaUrl: values.socialMediaUrl,

                    entityMasterId: values.entityMasterId ? parseInt(values.entityMasterId) : null,
                    entityTypeId: values.entityTypeId ? parseInt(values.entityTypeId) : null,
                    opportunityTypeId: values.opportunityTypeId ? parseInt(values.opportunityTypeId) : null,

                    source: values.source,
                    followupDetails: values.followupDetails,
                    followupDate: values.followupDate,
                    remark: values.remark,
                    opportunityApplicationId: values.opportunityApplicationId ? parseInt(values.opportunityApplicationId) : null,
                    financeTransactionCode: values.financeTransactionCode,

                    userId: localUserObj?.id,
                    isShortListed: values.isShortListed,
                    status: true
                };

                const formData = new FormData();
                formData.append('opportunityApplicationInterviewReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                saveOpportunityApplicationInterview({
                    token: localUserObj?.token,
                    payload: formData,
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {

                const payload = {
                    opportunityId: values.opportunityId ? parseInt(values.opportunityId) : null,
                    opportunityCode: values.opportunityCode,

                    opportunityAllocatedById: values.opportunityAllocatedById ? parseInt(values.opportunityAllocatedById) : null,
                    entityTypeAllocatedById: values.entityTypeAllocatedById ? parseInt(values.entityTypeAllocatedById) : null,

                    opportunityAllocationToId: values.opportunityAllocationToId ? parseInt(values.opportunityAllocationToId) : null,
                    entityTypeAllocatedToId: values.entityTypeAllocatedToId ? parseInt(values.entityTypeAllocatedToId) : null,

                    opportunityFor: values.opportunityFor,
                    opportunityAllocationDate: values.opportunityAllocationDate,
                    opportunityAllocationStatus: values.opportunityAllocationStatus,

                    panelApprovalStatus: values.panelApprovalStatus,
                    panelReviewDate: values.panelReviewDate,

                    memberInterviewRecordId: values.memberInterviewRecordId ? parseInt(values.memberInterviewRecordId) : null,

                    allocationType: values.allocationType,
                    opportunityAllocationRemark: values.opportunityAllocationRemark,

                    opportunityDetailsDoc: values.opportunityDetailsDoc,
                    memberRole: values.memberRole,

                    financeTransactionCode: values.financeTransactionCode,

                    userId: localUserObj?.id,
                    organizationEntityId: values.organizationEntityId ? parseInt(values.organizationEntityId) : null,
                    status: true
                };

                const formData = new FormData();
                formData.append('opportunityAllocationReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                saveOpportunityAllocation({
                    token: localUserObj?.token,
                    payload: formData,
                });
            } else if (props.reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {

                const payload = {
                    opportunityId: values.opportunityId ? parseInt(values.opportunityId) : null,

                    memberId: values.memberId ? parseInt(values.memberId) : null,
                    entityTypeId: values.entityTypeId ? parseInt(values.entityTypeId) : null,

                    interviewedById: values.interviewedById ? parseInt(values.interviewedById) : null,
                    entityTypeInterviewerId: values.entityTypeInterviewerId ? parseInt(values.entityTypeInterviewerId) : null,

                    interviewDate: values.interviewDate,
                    interviewType: values.interviewType,
                    interviewScore: values.interviewScore ? parseInt(values.interviewScore) : null,
                    interviewAssessment: values.interviewAssessment,

                    panelDecision: values.panelDecision,
                    remarksFromPanel: values.remarksFromPanel,

                    interviewVideoLink: values.interviewVideoLink,

                    opportunityCode: values.opportunityCode,
                    financeTransactionCode: values.financeTransactionCode,

                    userId: localUserObj?.id,
                    entityId: values.entityId ? parseInt(values.entityId) : null,

                    status: true
                };

                const formData = new FormData();
                formData.append('memberInterviewRecordReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                saveMemberInterviewRecord({
                    token: localUserObj?.token,
                    payload: formData,
                });
            }

        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
                const payload = {
                    id: props?.data.id,
                    code: values.code,
                    name: values.name,
                    description: values.description,
                    opportunityProvider: values.opportunityProvider,
                    opportunityStartDate: values.opportunityStartDate,
                    opportunityEndDate: values.opportunityEndDate,
                    opportunityStatus: values.opportunityStatus,
                    opportunityTypeId: values.opportunityTypeId ? parseInt(values.opportunityTypeId) : null,
                    eventVenue: values.eventVenue,
                    eventType: values.eventType,
                    criteria: values.criteria,
                    assetTypeId: values.assetTypeId ? parseInt(values.assetTypeId) : null,
                    assetsId: values.assetsId ? parseInt(values.assetsId) : null,
                    quantity: values.quantity ? parseFloat(values.quantity) : null,
                    uom: values.uom,
                    referrerEntityId: values.referrerEntityId ? parseInt(values.referrerEntityId) : null,
                    remarks: values.remarks,
                    userId: localUserObj?.id,
                    entityTypeId: values.entityTypeId ? parseInt(values.entityTypeId) : null,
                    entityId: values.entityId ? parseInt(values.entityId) : null,
                    status: props?.data.status,
                };

                updateOpportunityMaster({
                    id: props?.data.id,
                    token: localUserObj?.token,
                    payload: payload,
                })

            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
                const payload = {
                    id: props?.data.id,
                    code: values.code,
                    name: values.name,
                    description: values.description,
                    // llmRequest: values.llmRequest,
                    // llmResponse: values.llmResponse,
                    // Convert comma-separated strings to arrays
                    sdgGoals: [values.sdgGoals],
                    investmentMandateTypeId: values.investmentMandateTypeId ? parseInt(values.investmentMandateTypeId) : null,
                    sector: [values.sector],
                    remarks: values.remarks,
                    status: props?.data.status,
                };

                updateOpportunityType({
                    id: props?.data.id,
                    token: localUserObj?.token,
                    payload: payload,
                })
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {

                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    email: values.email,
                    code: values.code,
                    phoneNumber: values.phoneNumber,
                    socialMediaUrl: values.socialMediaUrl,

                    entityMasterId: values.entityMasterId ? parseInt(values.entityMasterId) : null,
                    entityTypeId: values.entityTypeId ? parseInt(values.entityTypeId) : null,
                    opportunityTypeId: values.opportunityTypeId ? parseInt(values.opportunityTypeId) : null,

                    source: values.source,
                    followupDetails: values.followupDetails,
                    followupDate: values.followupDate,
                    remark: values.remark,
                    attachment: values.attachment,
                    llmResponse: values.llmResponse,

                    opportunityId: values.opportunityId ? parseInt(values.opportunityId) : null,
                    financeTransactionCode: values.financeTransactionCode,

                    userId: localUserObj?.id,
                    shortListed: values.shortListed,
                    status: props?.data.status
                };

                const formData = new FormData();
                formData.append('opportunityApplicationReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                updateOpportunityApplication({
                    id: props.data.id,
                    token: localUserObj?.token,
                    payload: formData,
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {

                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    email: values.email,
                    phoneNumber: values.phoneNumber,
                    socialMediaUrl: values.socialMediaUrl,

                    entityMasterId: values.entityMasterId ? parseInt(values.entityMasterId) : null,
                    entityTypeId: values.entityTypeId ? parseInt(values.entityTypeId) : null,
                    opportunityTypeId: values.opportunityTypeId ? parseInt(values.opportunityTypeId) : null,

                    source: values.source,
                    followupDetails: values.followupDetails,
                    followupDate: values.followupDate,
                    remark: values.remark,
                    attachment: values.attachment,
                    llmResponse: values.llmResponse,

                    opportunityApplicationId: values.opportunityApplicationId ? parseInt(values.opportunityApplicationId) : null,
                    financeTransactionCode: values.financeTransactionCode,

                    userId: localUserObj?.id,
                    isShortListed: values.isShortListed,
                    status: props?.data.status
                };

                const formData = new FormData();
                formData.append('opportunityApplicationInterviewReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                updateOpportunityApplicationInterview({
                    id: props.data.id,
                    token: localUserObj?.token,
                    payload: formData,
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {

                const payload = {
                    id: props.data.id,

                    opportunityId: values.opportunityId ? parseInt(values.opportunityId) : null,
                    opportunityCode: values.opportunityCode,

                    opportunityAllocatedById: values.opportunityAllocatedById ? parseInt(values.opportunityAllocatedById) : null,
                    entityTypeAllocatedById: values.entityTypeAllocatedById ? parseInt(values.entityTypeAllocatedById) : null,

                    opportunityAllocationToId: values.opportunityAllocationToId ? parseInt(values.opportunityAllocationToId) : null,
                    entityTypeAllocatedToId: values.entityTypeAllocatedToId ? parseInt(values.entityTypeAllocatedToId) : null,

                    opportunityFor: values.opportunityFor,
                    opportunityAllocationDate: values.opportunityAllocationDate,
                    opportunityAllocationStatus: values.opportunityAllocationStatus,

                    panelApprovalStatus: values.panelApprovalStatus,
                    panelReviewDate: values.panelReviewDate,

                    memberInterviewRecordId: values.memberInterviewRecordId ? parseInt(values.memberInterviewRecordId) : null,

                    allocationType: values.allocationType,
                    opportunityAllocationRemark: values.opportunityAllocationRemark,

                    opportunityDetailsDoc: values.opportunityDetailsDoc,
                    fileUpload: values.fileUpload,
                    memberRole: values.memberRole,

                    financeTransactionCode: values.financeTransactionCode,

                    userId: localUserObj?.id,
                    organizationEntityId: values.organizationEntityId ? parseInt(values.organizationEntityId) : null,
                    status: props?.data.status
                };

                const formData = new FormData();
                formData.append('opportunityAllocationReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                updateOpportunityAllocation({
                    id: props.data.id,
                    token: localUserObj?.token,
                    payload: formData,
                });
            } else if (props.reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {

                const payload = {
                    id: props.data.id,

                    opportunityId: values.opportunityId ? parseInt(values.opportunityId) : null,

                    memberId: values.memberId ? parseInt(values.memberId) : null,
                    entityTypeId: values.entityTypeId ? parseInt(values.entityTypeId) : null,

                    interviewedById: values.interviewedById ? parseInt(values.interviewedById) : null,
                    entityTypeInterviewerId: values.entityTypeInterviewerId ? parseInt(values.entityTypeInterviewerId) : null,

                    interviewDate: values.interviewDate,
                    interviewType: values.interviewType,
                    interviewScore: values.interviewScore ? parseInt(values.interviewScore) : null,
                    interviewAssessment: values.interviewAssessment,

                    panelDecision: values.panelDecision,
                    remarksFromPanel: values.remarksFromPanel,

                    interviewVideoLink: values.interviewVideoLink,
                    fileUpload: values.fileUpload,

                    opportunityCode: values.opportunityCode,
                    financeTransactionCode: values.financeTransactionCode,

                    userId: localUserObj?.id,
                    entityId: values.entityId ? parseInt(values.entityId) : null,

                    dateTimestamp: values.dateTimestamp,
                    status: props?.data.status
                };

                const formData = new FormData();
                formData.append('memberInterviewRecordReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file', file);

                updateMemberInterviewRecord({
                    id: props.data.id,
                    token: localUserObj?.token,
                    payload: formData,
                });
            }
        }
    };

    const handleBulkUpload = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };

    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
                bulkSaveOpportunityType({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
                bulkSaveOpportunityMaster({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
                bulkSaveOpportunityApplication({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
                bulkSaveOpportunityApplicationInterview({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
                bulkSaveOpportunityAllocation({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
                bulkSaveMemberInterviewRecord({
                    token: localUserObj?.token,
                    payload: formData
                });
            }
        }
    }

    useEffect(() => {
        if (saveOpportunityTypeResponse.isSuccess) {
            const response: any = saveOpportunityTypeResponse.data;
            alertMessage("Sponsor Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveOpportunityTypeResponse.isError) {
            let response: any = saveOpportunityTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveOpportunityTypeResponse.isSuccess, saveOpportunityTypeResponse.isError]);

    useEffect(() => {
        if (saveOpportunityMasterResponse.isSuccess) {
            const response: any = saveOpportunityMasterResponse.data;
            alertMessage("Opportunity Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveOpportunityMasterResponse.isError) {
            let response: any = saveOpportunityMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveOpportunityMasterResponse.isSuccess, saveOpportunityMasterResponse.isError]);

    useEffect(() => {
        if (saveOpportunityApplicationResponse.isSuccess) {
            const response: any = saveOpportunityApplicationResponse.data;
            alertMessage("Opportunity Application added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveOpportunityApplicationResponse.isError) {
            let response: any = saveOpportunityApplicationResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveOpportunityApplicationResponse.isSuccess, saveOpportunityApplicationResponse.isError]);

    useEffect(() => {
        if (saveOpportunityApplicationInterviewResponse.isSuccess) {
            const response: any = saveOpportunityApplicationInterviewResponse.data;
            alertMessage("Opportunity ApplicationInterview added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveOpportunityApplicationInterviewResponse.isError) {
            let response: any = saveOpportunityApplicationInterviewResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveOpportunityApplicationInterviewResponse.isSuccess, saveOpportunityApplicationInterviewResponse.isError]);


    useEffect(() => {
        if (saveOpportunityAllocationResponse.isSuccess) {
            const response: any = saveOpportunityAllocationResponse.data;
            alertMessage("Opportunity Allocation added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveOpportunityAllocationResponse.isError) {
            let response: any = saveOpportunityAllocationResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveOpportunityAllocationResponse.isSuccess, saveOpportunityAllocationResponse.isError]);

    useEffect(() => {
        if (saveMemberInterviewRecordResponse.isSuccess) {
            const response: any = saveMemberInterviewRecordResponse.data;
            alertMessage("Member Master Record added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveMemberInterviewRecordResponse.isError) {
            let response: any = saveMemberInterviewRecordResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveMemberInterviewRecordResponse.isSuccess, saveMemberInterviewRecordResponse.isError]);

    useEffect(() => {
        if (saveToProjectRes.isSuccess) {
            console.log(saveToProjectRes)
            const response: any = saveToProjectRes.data;
            alertMessage("Added to project successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveToProjectRes.isError) {
            let response: any = saveToProjectRes?.error;
            alertMessage(response, "error");
        }
    }, [saveToProjectRes.isSuccess, saveToProjectRes.isError]);

    useEffect(() => {
        if (saveToAuditRes.isSuccess) {
            const response: any = saveToAuditRes.data;
            alertMessage("Added to audit successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveToAuditRes.isError) {
            let response: any = saveToAuditRes?.error;
            alertMessage(response, "error");
        }
    }, [saveToAuditRes.isSuccess, saveToAuditRes.isError]);


    //bulk save
    useEffect(() => {
        if (bulkSaveOpportunityTypeResponse.isSuccess) {
            const response: any = bulkSaveOpportunityTypeResponse.data;
            alertMessage("Opportunity Type added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveOpportunityTypeResponse.isError) {
            let response: any = bulkSaveOpportunityTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveOpportunityTypeResponse.isSuccess, bulkSaveOpportunityTypeResponse.isError]);

    useEffect(() => {
        if (bulkSaveOpportunityMasterResponse.isSuccess) {
            const response: any = bulkSaveOpportunityMasterResponse.data;
            alertMessage("Opportunity Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveOpportunityMasterResponse.isError) {
            let response: any = bulkSaveOpportunityMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveOpportunityMasterResponse.isSuccess, bulkSaveOpportunityMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveOpportunityApplicationResponse.isSuccess) {
            const response: any = bulkSaveOpportunityApplicationResponse.data;
            alertMessage("Opportunity Application added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveOpportunityApplicationResponse.isError) {
            let response: any = bulkSaveOpportunityApplicationResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveOpportunityApplicationResponse.isSuccess, bulkSaveOpportunityApplicationResponse.isError]);

    useEffect(() => {
        if (bulkSaveOpportunityApplicationInterviewResponse.isSuccess) {
            const response: any = bulkSaveOpportunityApplicationInterviewResponse.data;
            alertMessage("Opportunity ApplicationInterview added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveOpportunityApplicationInterviewResponse.isError) {
            let response: any = bulkSaveOpportunityApplicationInterviewResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveOpportunityApplicationInterviewResponse.isSuccess, bulkSaveOpportunityApplicationInterviewResponse.isError]);

    useEffect(() => {
        if (bulkSaveOpportunityAllocationResponse.isSuccess) {
            const response: any = bulkSaveOpportunityAllocationResponse.data;
            alertMessage("Opportunity Allocation added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveOpportunityAllocationResponse.isError) {
            let response: any = bulkSaveOpportunityAllocationResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveOpportunityAllocationResponse.isSuccess, bulkSaveOpportunityAllocationResponse.isError]);

    useEffect(() => {
        if (bulkSaveMemberInterviewRecordResponse.isSuccess) {
            const response: any = bulkSaveMemberInterviewRecordResponse.data;
            alertMessage("Member Interview Record added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveMemberInterviewRecordResponse.isError) {
            let response: any = bulkSaveMemberInterviewRecordResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveMemberInterviewRecordResponse.isSuccess, bulkSaveMemberInterviewRecordResponse.isError]);

    useEffect(() => {
        if (updateOpportunityTypeResponse.isSuccess) {
            const response: any = updateOpportunityTypeResponse.data;
            alertMessage("Opportunity Type updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateOpportunityTypeResponse.isError) {
            let response: any = updateOpportunityTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateOpportunityTypeResponse.isSuccess, updateOpportunityTypeResponse.isError]);

    useEffect(() => {
        if (updateOpportunityApplicationResponse.isSuccess) {
            const response: any = updateOpportunityApplicationResponse.data;
            alertMessage("Opportunity Application updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateOpportunityApplicationResponse.isError) {
            let response: any = updateOpportunityApplicationResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateOpportunityApplicationResponse.isSuccess, updateOpportunityApplicationResponse.isError]);

    useEffect(() => {
        if (updateOpportunityApplicationInterviewResponse.isSuccess) {
            const response: any = updateOpportunityApplicationInterviewResponse.data;
            alertMessage("Opportunity Application Interview updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateOpportunityApplicationInterviewResponse.isError) {
            let response: any = updateOpportunityApplicationInterviewResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateOpportunityApplicationInterviewResponse.isSuccess, updateOpportunityApplicationInterviewResponse.isError]);

    useEffect(() => {
        if (updateOpportunityAllocationResponse.isSuccess) {
            const response: any = updateOpportunityAllocationResponse.data;
            alertMessage("Opportunity Allocation updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateOpportunityAllocationResponse.isError) {
            let response: any = updateOpportunityAllocationResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateOpportunityAllocationResponse.isSuccess, updateOpportunityAllocationResponse.isError]);

    useEffect(() => {
        if (updateMemberInterviewRecordResponse.isSuccess) {
            const response: any = updateMemberInterviewRecordResponse.data;
            alertMessage("Member Interview Record updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateMemberInterviewRecordResponse.isError) {
            let response: any = updateMemberInterviewRecordResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateMemberInterviewRecordResponse.isSuccess, updateMemberInterviewRecordResponse.isError]);

    useEffect(() => {
        if (updateOpportunityMasterResponse.isSuccess) {
            const response: any = updateOpportunityMasterResponse.data;
            alertMessage("Opportunity Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateOpportunityMasterResponse.isError) {
            let response: any = updateOpportunityMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateOpportunityMasterResponse.isSuccess, updateOpportunityMasterResponse.isError]);

    useEffect(() => {
        if (opportunityTypeByIdResponse.isSuccess) {
            setGetByIdData(opportunityTypeByIdResponse.data);
        } else if (opportunityTypeByIdResponse.isError) {
            let response: any = opportunityTypeByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [opportunityTypeByIdResponse.isSuccess, opportunityTypeByIdResponse.isError]);

    useEffect(() => {
        if (opportunityMasterByIdResponse.isSuccess) {
            setGetByIdData(opportunityMasterByIdResponse.data);
        } else if (opportunityMasterByIdResponse.isError) {
            let response: any = opportunityMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [opportunityMasterByIdResponse.isSuccess, opportunityMasterByIdResponse.isError]);

    useEffect(() => {
        if (opportunityApplicationByIdResponse.isSuccess) {
            setGetByIdData(opportunityApplicationByIdResponse.data);
        } else if (opportunityApplicationByIdResponse.isError) {
            let response: any = opportunityApplicationByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [opportunityApplicationByIdResponse.isSuccess, opportunityApplicationByIdResponse.isError]);

    useEffect(() => {
        if (opportunityApplicationInterviewByIdResponse.isSuccess) {
            setGetByIdData(opportunityApplicationInterviewByIdResponse.data);
        } else if (opportunityApplicationInterviewByIdResponse.isError) {
            let response: any = opportunityApplicationInterviewByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [opportunityApplicationInterviewByIdResponse.isSuccess, opportunityApplicationInterviewByIdResponse.isError]);

    useEffect(() => {
        if (opportunityAllocationByIdResponse.isSuccess) {
            setGetByIdData(opportunityAllocationByIdResponse.data);
        } else if (opportunityAllocationByIdResponse.isError) {
            let response: any = opportunityAllocationByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [opportunityAllocationByIdResponse.isSuccess, opportunityAllocationByIdResponse.isError]);

    useEffect(() => {
        if (memberInterviewRecordByIdResponse.isSuccess) {
            setGetByIdData(memberInterviewRecordByIdResponse.data);
        } else if (memberInterviewRecordByIdResponse.isError) {
            let response: any = memberInterviewRecordByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [memberInterviewRecordByIdResponse.isSuccess, memberInterviewRecordByIdResponse.isError]);

    useEffect(() => {
        if (findAllOpportunityTypeRes.isSuccess) {
            dispatch(setAllOpportunityType(findAllOpportunityTypeRes));
        } else if (findAllOpportunityTypeRes.isError) {
            alertMessage("Error while fetching Opportunity Type", "error");
        }
    }, [findAllOpportunityTypeRes.isSuccess, findAllOpportunityTypeRes.isError]);

    useEffect(() => {
        if (findAllOpportunityRes.isSuccess) {
            dispatch(setAllOpportunityMaster(findAllOpportunityRes));
        } else if (findAllOpportunityRes.isError) {
            alertMessage("Error while fetching Opportunities", "error");
        }
    }, [findAllOpportunityRes.isSuccess, findAllOpportunityRes.isError]);

    useEffect(() => {
        if (findAllOpportunityApplicationRes.isSuccess) {
            dispatch(setAllOpportunityApplication(findAllOpportunityApplicationRes));
        } else if (findAllOpportunityApplicationRes.isError) {
            alertMessage("Error while fetching Opportunities", "error");
        }
    }, [findAllOpportunityApplicationRes.isSuccess, findAllOpportunityApplicationRes.isError]);

    useEffect(() => {
        if (findAllInvestmentMandateTypeRes.isSuccess) {
            dispatch(setAllInvestmentMandateType(findAllInvestmentMandateTypeRes));
        } else if (findAllInvestmentMandateTypeRes.isError) {
            alertMessage("Error while fetching Investment Mandate Type", "error");
        }
    }, [findAllInvestmentMandateTypeRes.isSuccess, findAllInvestmentMandateTypeRes.isError]);

    useEffect(() => {
        if (findAllAssetsResponse.isSuccess) {
            dispatch(setAllAssets(findAllAssetsResponse));
        } else if (findAllAssetsResponse.isError) {
            alertMessage("Error while fetching Assets", "error");
        }
    }, [findAllAssetsResponse.isSuccess, findAllAssetsResponse.isError]);

    useEffect(() => {
        if (findAllAssetTypeResponse.isSuccess) {
            dispatch(setAllAssetType(findAllAssetTypeResponse));
        } else if (findAllAssetTypeResponse.isError) {
            alertMessage("Error while fetching Asset Type", "error");
        }
    }, [findAllAssetTypeResponse.isSuccess, findAllAssetTypeResponse.isError]);

    useEffect(() => {
        if (findAllEntityMasterResponse.isSuccess) {
            dispatch(setAllEntityMaster(findAllEntityMasterResponse));
        } else if (findAllEntityMasterResponse.isError) {
            alertMessage("Error while fetching Entity Master", "error");
        }
    }, [findAllEntityMasterResponse.isSuccess, findAllEntityMasterResponse.isError]);

    useEffect(() => {
        if (findAllEntityTypeResponse.isSuccess) {
            dispatch(setAllEntityTypeMaster(findAllEntityTypeResponse));
        } else if (findAllEntityTypeResponse.isError) {
            alertMessage("Error while fetching Entity Type Master", "error");
        }
    }, [findAllEntityTypeResponse.isSuccess, findAllEntityTypeResponse.isError]);

    useEffect(() => {
        if (findAllMemberInterviewRecordResponse.isSuccess) {
            dispatch(setAllMemberInterviewRecord(findAllMemberInterviewRecordResponse));
        } else if (findAllMemberInterviewRecordResponse.isError) {
            alertMessage("Error while fetching Member Interview Record", "error");
        }
    }, [findAllMemberInterviewRecordResponse.isSuccess, findAllMemberInterviewRecordResponse.isError]);

    // upload file...............................
    const fileHandler = (e: any, fileNo: any) => {

        const fileName = e.target.files[0].name;
        setFileName(fileName)
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();
        setFile(e.target.files[0]);
    };

    useEffect(() => {
        if (!setFieldValueRef.current || !formikValuesRef.current) return;

        const currentAssetType = formikValuesRef.current.assetTypeId;

        if (
            prevAssetTypeRef.current &&
            currentAssetType &&
            prevAssetTypeRef.current !== currentAssetType
        ) {
            // reset asset when asset type changes
            setFieldValueRef.current("assetsId", "");
        }

        prevAssetTypeRef.current = currentAssetType;

    }, [allAssetsData, allEntityMasterData, allOpportuntiyData]);

    const handleDueDiligence = async (values: any) => {

        // console.log(values)

        let payload = {};

        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            payload = {

                socialMediaUrl: props?.data?.socialMediaUrl,
                userId: localUserObj.id,
                entityTypeName: props?.data?.entityType ? props?.data?.entityType.name : null,
                entityMasterName: props?.data?.entityMaster ? props?.data?.entityMaster.name : null,
                opportunityTypeName: props?.data?.opportunityType ? props?.data?.opportunityType.name : null,
                opportunityName: props?.data?.opportunity ? props?.data?.opportunity.name : null,
                source: REPORT_NAME.OPPORTUNITY_APPLICATION,
                actionType: props.actionType,
                opportunityApplicationId: props.data.id,
            };
        } else {
            payload = {
                socialMediaUrl: values.socialMediaUrl,
                userId: localUserObj.id,
                entityTypeName: values.entityTypeId
                    ? allEntityTypeData.find((t: any) => t.id === values.entityTypeId)?.name
                    : "",
                entityMasterName: values.entityTypeId
                    ? allEntityMasterData.find((t: any) => t.id === values.entityTypeId)?.name
                    : "",
                opportunityTypeName: values.entityTypeId
                    ? allOpportuntiyTypeData.find((t: any) => t.id === values.entityTypeId)?.name
                    : "",
                opportunityName: values.entityTypeId
                    ? allOpportuntiyData.find((t: any) => t.id === values.entityTypeId)?.name
                    : "",
                source: REPORT_NAME.OPPORTUNITY_APPLICATION,
                actionType: props.actionType
            };
        }

        getOpportunityDueDiligence({
            token: localUserObj?.token,
            payload: payload,
        })
    };

    const handleAddToProject = (values: any) => {
        //API call to save project
        // console.log("Add to project", values);

        const payload = {
            opportunityApplicationId: props?.data?.id,
            status: true,
            id: 0,
            name: values.opportunityId
                ? allOpportuntiyData.find((t: any) => t.id === values.opportunityId)?.name
                : "",
            description: values.opportunityId
                ? allOpportuntiyData.find((t: any) => t.id === values.opportunityId)?.description
                : "",
            departmentId: values.entityTypeId ? parseInt(values.entityTypeId) : "",
            departmentName: values.entityTypeId
                ? allEntityTypeData.find((t: any) => t.id === values.entityTypeId)?.name
                : "",
            orgId: values.entityMasterId ? parseInt(values.entityMasterId) : "",
            orgName: values.entityMasterId
                ? allEntityMasterData.find((t: any) => t.id === values.entityMasterId)?.name
                : "",
            projectTypeId: values.opportunityTypeId ? parseInt(values.opportunityTypeId) : "",
            projectTypeName: values.opportunityTypeId
                ? allOpportuntiyTypeData.find((t: any) => t.id === values.opportunityTypeId)?.name
                : "",
        }

        saveToProject({
            token: localUserObj?.token,
            payload: payload,
        });
    };

    const handleAddToAudit = (values: any) => {
        // navigate or API call
        // console.log("Add to Audit", values);
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by this browser");
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                const payload = {
                    opportunityApplicationId: props?.data?.id,
                    status: true,
                    id: 0,
                    name: values.opportunityId
                        ? allOpportuntiyData.find((t: any) => t.id === values.opportunityId)?.name
                        : "",
                    auditCode: values.opportunityId
                        ? allOpportuntiyData.find((t: any) => t.id === values.opportunityId)?.code
                        : "",
                    userId: localUserObj?.id,
                    auditType: "Due Diligence",
                    scopeOfAudit: "Due Diligence",
                    actualDescription: values.opportunityId
                        ? allOpportuntiyData.find((t: any) => t.id === values.opportunityId)?.description
                        : "",
                    organizationId: values.entityMasterId ? parseInt(values.entityMasterId) : "",
                    organizationName: values.entityMasterId
                        ? allEntityMasterData.find((t: any) => t.id === values.entityMasterId)?.name
                        : "",

                    // ✅ ADD THESE (MANDATORY)
                    latitude: latitude,
                    longitude: longitude
                };

                const formData = new FormData();
                formData.append(
                    "auditReqDTO",
                    new Blob([JSON.stringify(payload)], { type: "application/json" })
                );

                saveToAudit({
                    token: localUserObj?.token,
                    payload: formData
                });
            },
            (error) => {
                console.error(error);
                alert("Location access is required to add audit");
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    const handleAddToFinance = (values: any) => {
        // console.log("Add to finance", values);

        const payload = {
            status: true,
            name: values.opportunityId
                ? allOpportuntiyData.find((t: any) => t.id === values.opportunityId)?.name
                : "",
            code: values.opportunityId
                ? allOpportuntiyData.find((t: any) => t.id === values.opportunityId)?.code
                : "",
            dependentOrgCode: values.entityMasterId
                ? allEntityMasterData.find((t: any) => t.id === values.entityMasterId)?.name
                : "",
            organizationType: "dependent",
            opportunityApplicationId: props?.data?.id,
        }

        saveToFinance({
            token: localUserObj?.token,
            payload: payload,
        });
    }

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" }
                )}

            >
                <Modal.Header closeButton>

                    <Modal.Title
                        className="fw-bold text-accent"
                        style={{ fontSize: "1rem" }}
                    >
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {/* {props.reportName} */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {saveOpportunityTypeResponse.isLoading ||
                        saveOpportunityMasterResponse.isLoading ||
                        saveOpportunityApplicationResponse.isLoading ||
                        saveOpportunityAllocationResponse.isLoading ||
                        saveMemberInterviewRecordResponse.isLoading ||
                        saveOpportunityApplicationInterviewResponse.isLoading ||

                        bulkSaveOpportunityTypeResponse.isLoading ||
                        bulkSaveOpportunityMasterResponse.isLoading ||
                        bulkSaveOpportunityApplicationResponse.isLoading ||
                        bulkSaveOpportunityAllocationResponse.isLoading ||
                        bulkSaveMemberInterviewRecordResponse.isLoading ||
                        bulkSaveOpportunityApplicationInterviewResponse.isLoading ||

                        updateOpportunityTypeResponse.isLoading ||
                        updateOpportunityMasterResponse.isLoading ||
                        updateOpportunityApplicationResponse.isLoading ||
                        updateOpportunityAllocationResponse.isLoading ||
                        updateMemberInterviewRecordResponse.isLoading ||
                        updateOpportunityApplicationInterviewResponse.isLoading ||

                        opportunityTypeByIdResponse.isLoading ||
                        opportunityMasterByIdResponse.isLoading ||
                        opportunityApplicationByIdResponse.isLoading ||
                        opportunityAllocationByIdResponse.isLoading ||
                        memberInterviewRecordByIdResponse.isLoading ||
                        opportunityApplicationInterviewByIdResponse.isLoading ||

                        findAllOpportunityTypeRes.isLoading ||
                        findAllInvestmentMandateTypeRes.isLoading ||
                        findAllAssetsResponse.isLoading ||
                        findAllAssetTypeResponse.isLoading ||
                        findAllEntityMasterResponse.isLoading ||
                        findAllOpportunityApplicationRes.isLoading

                        ? (
                            <Loading />
                        ) : (
                            ""
                        )
                    }

                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}


                    {activeTab === "manual" && (
                        <Formik
                            validationSchema={validationSchema}
                            validateOnChange={true}
                            validateOnBlur={true}
                            enableReinitialize={true}
                            initialValues={
                                props.reportName === REPORT_NAME.OPPORTUNITY_MASTER ? {
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.code : "",
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.name : "",
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.description : "",
                                    opportunityProvider:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityProvider : "",
                                    opportunityStartDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityStartDate : "",
                                    opportunityEndDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityEndDate : "",
                                    opportunityStatus:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityStatus : "",
                                    opportunityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityType?.id : "",
                                    eventVenue:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.eventVenue : "",
                                    eventType:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.eventType : "",
                                    criteria:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.criteria : "",
                                    assetTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.assetType?.id : "",
                                    assetsId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.assets?.id : "",
                                    quantity:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.quantity : "",
                                    uom:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.uom : "",
                                    referrerEntityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.referrerEntityId : "",
                                    remarks:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.remarks : "",
                                    userId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.userId : "",
                                    entityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityTypeMaster?.id
                                            : "",
                                    entityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityMaster?.id : "",

                                } : props.reportName === REPORT_NAME.OPPORTUNITY_TYPE ? {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.name : "",
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.code : "",
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.description : "",
                                    llmRequest:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.llmRequest : "",
                                    llmResponse:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.llmResponse : "",
                                    sdgGoals:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.sdgGoals || [] : [],
                                    investmentMandateTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.investmentMandateType?.id : "",
                                    sector:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.sector || [] : [],
                                    remarks:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.remarks : "",

                                } : props.reportName === REPORT_NAME.OPPORTUNITY_APPLICATION ? {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.name : "",
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.code : "",
                                    email:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.email : "",
                                    phoneNumber:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.phoneNumber : "",
                                    socialMediaUrl:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.socialMediaUrl : "",
                                    entityMasterId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityMaster?.id : "",
                                    entityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityTypeMaster?.id : "",
                                    opportunityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityType?.id : "",
                                    source:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.source : "",
                                    followupDetails:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.followupDetails : "",
                                    followupDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.followupDate : "",
                                    remark:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.remark : "",
                                    attachment:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.attachment : "",
                                    llmResponse:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.llmResponse : "",
                                    opportunityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunity?.id : "",
                                    financeTransactionCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.financeTransactionCode : "",
                                    userId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.user?.id : "",
                                    shortListed:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.shortListed : "",

                                } : props.reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW ? {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.name : "",
                                    email:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.email : "",
                                    phoneNumber:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.phoneNumber : "",
                                    socialMediaUrl:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.socialMediaUrl : "",
                                    entityMasterId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityMaster?.id : "",
                                    entityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityTypeMaster?.id : "",
                                    opportunityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityType?.id : "",
                                    source:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.source : "",
                                    followupDetails:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.followupDetails : "",
                                    followupDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.followupDate : "",
                                    remark:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.remark : "",
                                    attachment:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.attachment : "",
                                    llmResponse:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.llmResponse : "",
                                    opportunityApplicationId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityApplication?.id : "",
                                    financeTransactionCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.financeTransactionCode : "",
                                    userId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.user?.id : "",
                                    isShortListed:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.isShortListed : "",


                                } : props.reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION ? {
                                    opportunityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunity?.id : "",

                                    opportunityCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityCode : "",
                                    //entity
                                    opportunityAllocatedById:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityAllocatedBy?.id : "",
                                    //entityType
                                    entityTypeAllocatedById:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityTypeAllocatedBy?.id : "",
                                    //entity
                                    opportunityAllocationToId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityAllocationTo?.id : "",

                                    entityTypeAllocatedToId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityTypeAllocatedTo?.id : "",

                                    opportunityFor:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityFor : "",

                                    opportunityAllocationDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityAllocationDate : "",

                                    opportunityAllocationStatus:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityAllocationStatus : "",

                                    panelApprovalStatus:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.panelApprovalStatus : "",

                                    panelReviewDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.panelReviewDate : "",

                                    memberInterviewRecordId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.memberInterviewRecords?.id : "",
                                    //primary / secondary
                                    allocationType:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.allocationType : "",

                                    opportunityAllocationRemark:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityAllocationRemark : "",

                                    opportunityDetailsDoc:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityDetailsDoc : "",

                                    memberRole:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.memberRole : "",

                                    financeTransactionCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.financeTransactionCode : "",

                                    userId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.user?.id : "",

                                    organizationEntityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.organizationEntity?.id : "",

                                } : props.reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS ? {
                                    opportunityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunity?.id : "",

                                    memberId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.member?.id : "",

                                    entityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityType?.id : "",

                                    interviewedById:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.interviewedBy?.id : "",

                                    entityTypeInterviewerId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.entityTypeInterviewer?.id : "",

                                    interviewDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.interviewDate : "",

                                    interviewType:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.interviewType : "",

                                    interviewScore:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.interviewScore : "",

                                    interviewAssessment:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.interviewAssessment : "",

                                    panelDecision:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.panelDecision : "",

                                    remarksFromPanel:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.remarksFromPanel : "",

                                    interviewVideoLink:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.interviewVideoLink : "",

                                    opportunityCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.opportunityCode : "",

                                    financeTransactionCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.financeTransactionCode : "",

                                    userId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.user?.id : "",

                                    entityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.organizationEntity?.id : "",
                                } : {}
                            }
                            onSubmit={handleSubmit}
                        >
                            {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => {
                                setFieldValueRef.current = setFieldValue;
                                formikValuesRef.current = values;

                                // Save setFieldValue so useEffect can access it
                                setFieldValueRef.current = setFieldValue;
                                const hasValue = (v: any) => v !== null && v !== undefined && v !== "";

                                const isDueDiligenceEnabled = () => {

                                    // UPDATE MODE
                                    if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
                                        return (
                                            hasValue(props.data?.entityTypeMaster?.id) &&
                                            hasValue(props.data?.entityMaster?.id) &&
                                            hasValue(props.data?.opportunityType?.id) &&
                                            hasValue(props.data?.opportunity?.id)
                                        );
                                    }

                                    // ADD MODE
                                    return (
                                        hasValue(values.entityTypeId) &&
                                        hasValue(values.entityMasterId) &&
                                        hasValue(values.opportunityTypeId) &&
                                        hasValue(values.opportunityId)
                                    );
                                };

                                return (
                                    <Form>
                                        <>
                                            {/* OpportunityMaster Fields */}
                                            {props.reportName === REPORT_NAME.OPPORTUNITY_MASTER && (
                                                <>
                                                    <div className="mt-3">
                                                        <div>
                                                            <div className="d-flex"> <div>Code</div>
                                                                <div style={{ color: "red" }}>*</div>
                                                            </div>
                                                            <input className="form-control form-control-sm w-100"
                                                                type="text"
                                                                aria-label=".form-control-sm example"
                                                                onChange={handleChange}
                                                                value={values.code}
                                                                name={"code"}
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="mt-3">
                                                        <div>
                                                            <div className="d-flex"> <div> {props.reportName} Name</div>
                                                                <div style={{ color: "red" }}>*</div>
                                                            </div>
                                                            <input className="form-control form-control-sm w-100"
                                                                type="text"
                                                                aria-label=".form-control-sm example"
                                                                onChange={handleChange}
                                                                value={values.name}
                                                                name={"name"}
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="mt-3">
                                                        <div>Description</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="description"
                                                            value={values.description}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Opportunity Type</div>
                                                        <select
                                                            className="form-select"
                                                            name="opportunityTypeId"
                                                            value={values.opportunityTypeId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Type</option>
                                                            {allOpportuntiyTypeData?.map((type: any) => (
                                                                <option key={type.id} value={type.id}>
                                                                    {type.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label">Entity Type</label>
                                                        <select
                                                            className="form-select"
                                                            name="entityTypeId"
                                                            value={values.entityTypeId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Entity Type</option>
                                                            {allEntityTypeData?.map((item: any) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>


                                                    <div className="mt-3">
                                                        <div>Entity</div>
                                                        <select
                                                            className="form-select"
                                                            name="entityId"
                                                            value={values.entityId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Entity</option>
                                                            {allEntityMasterData?.map((e: any) => (
                                                                <option key={e.id} value={e.id}>
                                                                    {e.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Asset Type</div>
                                                        <select
                                                            className="form-select"
                                                            name="assetTypeId"
                                                            value={values.assetTypeId}
                                                            onChange={(e: any) => {
                                                                handleChange(e);
                                                                // immediate reset (UX improvement)
                                                                setFieldValue("assetsId", "");
                                                            }}
                                                        >
                                                            <option value="">Select Asset Type</option>
                                                            {allAssetTypeData?.map((type: any) => (
                                                                <option key={type.id} value={type.id}>
                                                                    {type.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Asset</div>
                                                        <select
                                                            className="form-select"
                                                            name="assetsId"
                                                            value={values.assetsId}
                                                            onChange={handleChange}
                                                            disabled={!values.assetTypeId}
                                                        >
                                                            <option value="">Select Asset</option>
                                                            {allAssetsData
                                                                ?.filter(
                                                                    (a: any) =>
                                                                        a.assetType?.id === Number(values.assetTypeId)
                                                                )
                                                                .map((a: any) => (
                                                                    <option key={a.id} value={a.id}>
                                                                        {a.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Opportunity Provider</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="opportunityProvider"
                                                            value={values.opportunityProvider}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Opportunity Start Date</div>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="opportunityStartDate"
                                                            value={values.opportunityStartDate ? format(parseISO(values.opportunityStartDate), "yyyy-MM-dd") : ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Opportunity End Date</div>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="opportunityEndDate"
                                                            value={values.opportunityEndDate ? format(parseISO(values.opportunityEndDate), "yyyy-MM-dd") : ""}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Opportunity Status</div>
                                                        <select
                                                            className="form-select"
                                                            name="opportunityStatus"
                                                            value={values.opportunityStatus}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Status</option>
                                                            <option value="Active">Active</option>
                                                            <option value="Closed">Closed</option>
                                                            <option value="Draft">Draft</option>
                                                        </select>
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Event Venue</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="eventVenue"
                                                            value={values.eventVenue}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Event Type</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="eventType"
                                                            value={values.eventType}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Criteria</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="criteria"
                                                            value={values.criteria}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Quantity</div>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="quantity"
                                                            value={values.quantity}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>UOM</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="uom"
                                                            value={values.uom}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* <div className="mt-3">
                                                        <div>Referrer Percentage</div>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="referrerPercentage"
                                                            value={values.referrerPercentage}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Referrer Amount</div>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="referrerAmount"
                                                            value={values.referrerAmount}
                                                            onChange={handleChange}
                                                        />
                                                    </div> */}

                                                    <div className="mt-3">
                                                        <div>Remarks</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="remarks"
                                                            value={values.remarks}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </>
                                            )}

                                            {/* OpportunityType Fields */}
                                            {props.reportName === REPORT_NAME.OPPORTUNITY_TYPE && (
                                                <>
                                                    <div className="mt-3">
                                                        <div>
                                                            <div className="d-flex"> <div>Code</div>
                                                                <div style={{ color: "red" }}>*</div>
                                                            </div>
                                                            <input className="form-control form-control-sm w-100"
                                                                type="text"
                                                                aria-label=".form-control-sm example"
                                                                onChange={handleChange}
                                                                value={values.code}
                                                                name={"code"}
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="mt-3">
                                                        <div>
                                                            <div className="d-flex"> <div> {props.reportName} Name</div>
                                                                <div style={{ color: "red" }}>*</div>
                                                            </div>
                                                            <input className="form-control form-control-sm w-100"
                                                                type="text"
                                                                aria-label=".form-control-sm example"
                                                                onChange={handleChange}
                                                                value={values.name}
                                                                name={"name"}
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="mt-3">
                                                        <div>Description</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="description"
                                                            value={values.description}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* <div className="mt-3">
                                                    <div>LLM Request</div>
                                                    <textarea
                                                        className="form-control"
                                                        name="llmRequest"
                                                        value={values.llmRequest}
                                                        onChange={handleChange}
                                                    />
                                                </div>

                                                <div className="mt-3">
                                                    <div>LLM Response</div>
                                                    <textarea
                                                        className="form-control"
                                                        name="llmResponse"
                                                        value={values.llmResponse}
                                                        onChange={handleChange}
                                                    />
                                                </div> */}

                                                    <div className="mt-3">
                                                        <div>SDG Goals</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="sdgGoals"
                                                            value={values.sdgGoals}
                                                            onChange={handleChange}
                                                            placeholder="e.g., 1,2,3"
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Sector</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="sector"
                                                            value={values.sector}
                                                            onChange={handleChange}
                                                            placeholder="e.g., Finance,Health,Education"
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Investment Mandate Type</div>
                                                        <select
                                                            className="form-select"
                                                            name="investmentMandateTypeId"
                                                            value={values.investmentMandateTypeId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Mandate</option>
                                                            {allInvestmentMandateTypeData?.map((type: any) => (
                                                                <option key={type.id} value={type.id}>
                                                                    {type.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="mt-3">
                                                        <div>Remarks</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="remarks"
                                                            value={values.remarks}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </>
                                            )}

                                            {(props.reportName === REPORT_NAME.OPPORTUNITY_APPLICATION ||
                                                props.reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW
                                            ) && (
                                                    <>
                                                        {/* Entity Type Allocated By */}
                                                        <div className="mt-3">
                                                            <div>Entity Type</div>
                                                            <select
                                                                className="form-select"
                                                                name="entityTypeId"
                                                                value={values.entityTypeId}
                                                                onChange={(e: any) => {
                                                                    handleChange(e);
                                                                    // immediate reset (UX improvement)
                                                                    setFieldValue("entityMasterId", "");
                                                                }}
                                                            >
                                                                <option value="">Select Type</option>
                                                                {allEntityTypeData?.map((t: any) => (
                                                                    <option key={t.id} value={t.id}>{t.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        {/* Entity */}
                                                        <div className="mt-3">
                                                            <div>Entity</div>
                                                            <select
                                                                className="form-select"
                                                                name="entityMasterId"
                                                                value={values.entityMasterId}
                                                                onChange={handleChange}
                                                                disabled={!values.entityTypeId}
                                                            >
                                                                <option value="">Select Entity</option>
                                                                {allEntityMasterData?.
                                                                    filter(
                                                                        (e: any) =>
                                                                            e.entityType?.id === Number(values.entityTypeId)
                                                                    )
                                                                    .map((e: any) => (
                                                                        <option key={e.id} value={e.id}>{e.name}</option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                        {/* Opportunity Type */}
                                                        <div className="mt-3">
                                                            <div>Opportunity Type</div>
                                                            <select
                                                                className="form-select"
                                                                name="opportunityTypeId"
                                                                value={values.opportunityTypeId}
                                                                onChange={(e: any) => {
                                                                    handleChange(e);
                                                                    // immediate reset (UX improvement)
                                                                    setFieldValue("opportunityId", "");
                                                                }}
                                                            >
                                                                <option value="">Select Opportunity Type</option>
                                                                {allOpportuntiyTypeData?.map((o: any) => (
                                                                    <option key={o.id} value={o.id}>{o.name}</option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {props.reportName !== REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW && (
                                                            <>
                                                                {/* Opportunity */}
                                                                <div className="mt-3">
                                                                    <div>Opportunity</div>
                                                                    <select
                                                                        className="form-select"
                                                                        name="opportunityId"
                                                                        value={values.opportunityId}
                                                                        onChange={handleChange}
                                                                        disabled={!values.opportunityTypeId}
                                                                    >
                                                                        <option value="">Select Opportunity</option>
                                                                        {allOpportuntiyData
                                                                            ?.filter(
                                                                                (a: any) =>
                                                                                    a.opportunityType?.id === Number(values.opportunityTypeId)
                                                                            )
                                                                            .map((o: any) => (
                                                                                <option key={o.id} value={o.id}>
                                                                                    {o.code} - {o.name}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div></>
                                                        )}

                                                        {props.reportName !== REPORT_NAME.OPPORTUNITY_APPLICATION && (
                                                            <>
                                                                {/* Opportunity */}
                                                                <div className="mt-3">
                                                                    <div>Opportunity Application</div>
                                                                    <select
                                                                        className="form-select"
                                                                        name="opportunityApplicationId"
                                                                        value={values.opportunityApplicationId}
                                                                        onChange={handleChange}
                                                                    >
                                                                        <option value="">Select Opportunity Application</option>
                                                                        {allOpportuntiyData
                                                                            ?.filter(
                                                                                (a: any) =>
                                                                                    a.opportunityType?.id === Number(values.opportunityTypeId)
                                                                            )
                                                                            .map((o: any) => (
                                                                                <option key={o.id} value={o.id}>
                                                                                    {o.code} - {o.name}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div></>
                                                        )}

                                                        <div className="mt-3">
                                                            <div>
                                                                <div className="d-flex"> <div>Code</div>
                                                                    <div style={{ color: "red" }}>*</div>
                                                                </div>
                                                                <input className="form-control form-control-sm w-100"
                                                                    type="text"
                                                                    aria-label=".form-control-sm example"
                                                                    onChange={handleChange}
                                                                    value={values.code}
                                                                    name={"code"}
                                                                    required />
                                                            </div>
                                                        </div>
                                                        <div className="mt-3">
                                                            <div>
                                                                <div className="d-flex"> <div> {props.reportName} Name</div>
                                                                    <div style={{ color: "red" }}>*</div>
                                                                </div>
                                                                <input className="form-control form-control-sm w-100"
                                                                    type="text"
                                                                    aria-label=".form-control-sm example"
                                                                    onChange={handleChange}
                                                                    value={values.name}
                                                                    name={"name"}
                                                                    required />
                                                            </div>
                                                        </div>
                                                        <div className="mt-3">
                                                            <div>
                                                                <div className="d-flex">Email</div>
                                                                <input className="form-control form-control-sm w-100"
                                                                    type="text"
                                                                    aria-label=".form-control-sm example"
                                                                    onChange={handleChange}
                                                                    value={values.email}
                                                                    name={"email"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mt-3">
                                                            <div>
                                                                <div className="d-flex">Phone Number</div>
                                                                <input className="form-control form-control-sm w-100"
                                                                    type="text"
                                                                    aria-label=".form-control-sm example"
                                                                    onChange={handleChange}
                                                                    value={values.phoneNumber}
                                                                    name={"phoneNumber"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="mt-3">
                                                            <div>
                                                                <div className="d-flex">Social Media URL</div>
                                                                <input className="form-control form-control-sm w-100"
                                                                    type="text"
                                                                    aria-label=".form-control-sm example"
                                                                    onChange={handleChange}
                                                                    value={values.socialMediaUrl}
                                                                    name={"socialMediaUrl"}
                                                                    placeholder="linkedin, twitter, facebook"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="mt-3">
                                                            <div>Source</div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="source"
                                                                value={values.source}
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className="mt-3">
                                                            <div>Followup Details</div>
                                                            <textarea
                                                                className="form-control"
                                                                name="followupDetails"
                                                                value={values.followupDetails}
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className="mt-3">
                                                            <div>Followup Date</div>
                                                            <input
                                                                className="form-control form-control-sm w-50"
                                                                type="date"
                                                                aria-label=".form-control-sm example"
                                                                onChange={handleChange}
                                                                value={
                                                                    values.followupDate
                                                                        ? format(parseISO(values.followupDate), "yyyy-MM-dd")
                                                                        : ""
                                                                }
                                                                name="followupDate"
                                                            />
                                                        </div>

                                                        <div className="mt-3">
                                                            <div>Remark</div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="remark"
                                                                value={values.remark}
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        {/* Remark */}
                                                        <div className="mt-3">
                                                            <div>Finance Transaction Code</div>
                                                            <textarea
                                                                className="form-control"
                                                                name="financeTransactionCode"
                                                                value={values.financeTransactionCode}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className="form-check d-flex align-items-center gap-2 mb-2 ps-0 mt-2">
                                                            <label
                                                                htmlFor="shortListed"
                                                                className="form-check-label text-black fw-bold"
                                                            >
                                                                Is Shortlisted
                                                            </label>

                                                            <input
                                                                type="checkbox"
                                                                id="shortListed"
                                                                name="shortListed"
                                                                checked={Boolean(values.shortListed)}
                                                                onChange={(e) =>
                                                                    setFieldValue("shortListed", e.target.checked)
                                                                }
                                                                className="form-check-input m-0 border border-dark"
                                                            />

                                                        </div>
                                                        <div>
                                                            {getByIdData?.addedToAudit && (
                                                                <h3>Added to Audit</h3>
                                                            )}
                                                            {getByIdData?.addedToProject && (
                                                                <h3>Added to Project</h3>
                                                            )}
                                                            {getByIdData?.addedToFinance && (
                                                                <h3>Added to Finance</h3>
                                                            )}
                                                        </div>

                                                        {Boolean(values.shortListed) && (props.actionType === ACTION_TYPE.UPDATE_ACTION) && (
                                                            <div className="d-flex gap-2 mt-3">
                                                                {!props.data.addedToProject && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-width"
                                                                        onClick={() => handleAddToProject(values)}
                                                                    >
                                                                        Add to Project
                                                                    </button>
                                                                )}
                                                                {!props.data.addedToAudit && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-width"
                                                                        onClick={() => handleAddToAudit(values)}
                                                                    >
                                                                        Add to Audit
                                                                    </button>
                                                                )}
                                                                {!props.data.addedToFinance && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-info btn-width"
                                                                        onClick={() => handleAddToFinance(values)}
                                                                    >
                                                                        Add to Finance
                                                                    </button>
                                                                )}
                                                            </div>
                                                        )}

                                                        {/* Attachemnt*/}
                                                        <div className="mt-3">
                                                            <div>Attachemnt</div>
                                                            <div className="d-flex">
                                                                <input
                                                                    type="file"
                                                                    hidden
                                                                    id="fileUpload"
                                                                    onChange={(e: any) => {
                                                                        fileHandler(e, "file");
                                                                        setFieldValue("file", e.target.files[0]);
                                                                    }}
                                                                />
                                                                <label htmlFor="fileUpload" className="btn btn-primary mx-2  mt-3" style={{ width: "30%" }}>Upload file</label>
                                                                <p className="mt-4">{fileName}</p>
                                                            </div>
                                                        </div>
                                                        {props.reportName === REPORT_NAME.OPPORTUNITY_APPLICATION && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-block mt-3 mx-2 btn-width"
                                                                onClick={() => handleDueDiligence(props.actionType === ACTION_TYPE.UPDATE_ACTION ?
                                                                    props.data : values)}
                                                                disabled={!isDueDiligenceEnabled()}
                                                            >
                                                                Due Diligence
                                                            </button>
                                                        )}
                                                    </>
                                                )}

                                            {/* Opportunity Allocation Fields */}
                                            {props.reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION && (
                                                <>
                                                    {/* Opportunity */}
                                                    <div className="mt-3">
                                                        <div>Opportunity</div>
                                                        <select
                                                            className="form-select"
                                                            name="opportunityId"
                                                            value={values.opportunityId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Opportunity</option>
                                                            {allOpportuntiyData?.map((o: any) => (
                                                                <option key={o.id} value={o.id}>
                                                                    {o.code} - {o.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Opportunity Code */}
                                                    {/* <div className="mt-3">
                                                        <div>Opportunity Code</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="opportunityCode"
                                                            value={values.opportunityCode}
                                                            onChange={handleChange}
                                                        />
                                                    </div> */}

                                                    {/* Allocated By Entity */}
                                                    <div className="mt-3">
                                                        <div>Opportunity Allocated By (Entity)</div>
                                                        <select
                                                            className="form-select"
                                                            name="opportunityAllocatedById"
                                                            value={values.opportunityAllocatedById}
                                                            onChange={(e: any) => {
                                                                // set entityId normally
                                                                setFieldValue("opportunityAllocatedById", e.target.value);

                                                                if (e.target.value) {
                                                                    const selectedEntity = allEntityMasterData.find(
                                                                        (entity: any) => entity.id === Number(e.target.value)
                                                                    );

                                                                    if (selectedEntity?.entityType?.id) {
                                                                        setFieldValue("entityTypeAllocatedById", selectedEntity.entityType.id);
                                                                    }
                                                                } else {
                                                                    // reset entity type if entity is cleared
                                                                    setFieldValue("entityTypeAllocatedById", "");
                                                                }
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {allEntityMasterData?.map((e: any) => (
                                                                <option key={e.id} value={e.id}>
                                                                    {e.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Allocated By Entity Type */}
                                                    <div className="mt-3">
                                                        <div>Allocated By (Entity Type)</div>
                                                        <select
                                                            className="form-select"
                                                            name="entityTypeAllocatedById"
                                                            value={values.entityTypeAllocatedById}
                                                            onChange={handleChange}
                                                            disabled={!values.opportunityAllocatedById}
                                                        >
                                                            <option value="">Select</option>
                                                            {allEntityTypeData?.map((t: any) => (
                                                                <option key={t.id} value={t.id}>
                                                                    {t.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* AllocatedTo */}
                                                    <div className="mt-3">
                                                        <div>Opportunity Allocated To (Entity)</div>
                                                        <select
                                                            className="form-select"
                                                            name="opportunityAllocationToId"
                                                            value={values.opportunityAllocationToId}
                                                            onChange={(e: any) => {
                                                                // set entityId normally
                                                                setFieldValue("opportunityAllocationToId", e.target.value);

                                                                if (e.target.value) {
                                                                    const selectedEntity = allEntityMasterData.find(
                                                                        (entity: any) => entity.id === Number(e.target.value)
                                                                    );

                                                                    if (selectedEntity?.entityType?.id) {
                                                                        setFieldValue("entityTypeAllocatedToId", selectedEntity.entityType.id);
                                                                    }
                                                                } else {
                                                                    // reset entity type if entity is cleared
                                                                    setFieldValue("entityTypeAllocatedToId", "");
                                                                }
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {allEntityMasterData?.map((e: any) => (
                                                                <option key={e.id} value={e.id}>
                                                                    {e.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Entity Type allocated To */}
                                                    <div className="mt-3">
                                                        <div>Entity Type Allocated To</div>
                                                        <select
                                                            className="form-select"
                                                            name="entityTypeAllocatedToId"
                                                            value={values.entityTypeAllocatedToId}
                                                            onChange={handleChange}
                                                            disabled={!!values.opportunityAllocationToId}
                                                        >
                                                            <option value="">Select</option>
                                                            {allEntityTypeData?.map((t: any) => (
                                                                <option key={t.id} value={t.id}>
                                                                    {t.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Opportunity For */}
                                                    <div className="mt-3">
                                                        <div>Opportunity For</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="opportunityFor"
                                                            value={values.opportunityFor}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Allocation Date */}
                                                    <div className="mt-3">
                                                        <div>Opportunity Allocation Date</div>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="opportunityAllocationDate"
                                                            value={
                                                                values.opportunityAllocationDate
                                                                    ? format(parseISO(values.opportunityAllocationDate), "yyyy-MM-dd")
                                                                    : ""
                                                            }
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Opportunity Allocation Status */}
                                                    <div className="mt-3">
                                                        <div>Opportunity Allocation Status</div>
                                                        <select
                                                            className="form-select"
                                                            name="opportunityAllocationStatus"
                                                            value={values.opportunityAllocationStatus}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Status</option>
                                                            <option value="Allocated">Allocated</option>
                                                            <option value="Pending">Pending</option>
                                                            <option value="Rejected">Rejected</option>
                                                        </select>
                                                    </div>

                                                    {/* Panel Approval Status */}
                                                    <div className="mt-3">
                                                        <div>Panel Approval Status</div>
                                                        <select
                                                            className="form-select"
                                                            name="panelApprovalStatus"
                                                            value={values.panelApprovalStatus}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Approved">Approved</option>
                                                            <option value="Rejected">Rejected</option>
                                                            <option value="Pending">Pending</option>
                                                        </select>
                                                    </div>

                                                    {/* Panel Review Date */}
                                                    <div className="mt-3">
                                                        <div>Panel Review Date</div>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="panelReviewDate"
                                                            value={
                                                                values.panelReviewDate
                                                                    ? format(parseISO(values.panelReviewDate), "yyyy-MM-dd")
                                                                    : ""
                                                            }
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Member Interview Record */}
                                                    <div className="mt-3">
                                                        <div>Member Interview Record</div>
                                                        <select
                                                            className="form-select"
                                                            name="memberInterviewRecordId"
                                                            value={values.memberInterviewRecordId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Interview</option>
                                                            {allMemberInterviewRecords?.map((m: any) => (
                                                                <option key={m.id} value={m.id}>
                                                                    {m.member?.name} - {m.interviewDate}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Allocation Type */}
                                                    <div className="mt-3">
                                                        <div>Allocation Type</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="allocationType"
                                                            value={values.allocationType}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Remarks */}
                                                    <div className="mt-3">
                                                        <div>Opportunity Allocation Remark</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="opportunityAllocationRemark"
                                                            value={values.opportunityAllocationRemark}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Opportunity Details Doc</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="opportunityDetailsDoc"
                                                            value={values.opportunityDetailsDoc}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* File Upload */}
                                                    <div className="mt-3">
                                                        <div>File Upload</div>
                                                        <div className="d-flex">
                                                            <input
                                                                type="file"
                                                                hidden
                                                                id="fileUpload"
                                                                onChange={(e: any) => {
                                                                    fileHandler(e, "file");
                                                                    setFieldValue("file", e.target.files[0]);
                                                                }}
                                                            />
                                                            <label htmlFor="fileUpload" className="btn btn-primary mx-2  mt-3" style={{ width: "30%" }}>Upload file</label>
                                                            <p className="mt-4">{fileName}</p>
                                                        </div>
                                                    </div>

                                                    {/* Member Role */}
                                                    <div className="mt-3">
                                                        <div>Member Role</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="memberRole"
                                                            value={values.memberRole}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className="mt-3">
                                                        <div>Finance Transaction Code</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="financeTransactionCode"
                                                            value={values.financeTransactionCode}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Organization Entity */}
                                                    <div className="mt-3">
                                                        <div>Organization Entity</div>
                                                        <select
                                                            className="form-select"
                                                            name="organizationEntityId"
                                                            value={values.organizationEntityId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Entity</option>
                                                            {allEntityMasterData?.map((e: any) => (
                                                                <option key={e.id} value={e.id}>
                                                                    {e.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </>
                                            )}

                                            {/* Member Interview Record Fields */}
                                            {props.reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS && (
                                                <>
                                                    {/* Opportunity */}
                                                    <div className="mt-3">
                                                        <div>Opportunity</div>
                                                        <select
                                                            className="form-select"
                                                            name="opportunityId"
                                                            value={values.opportunityId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Opportunity</option>
                                                            {allOpportuntiyData?.map((o: any) => (
                                                                <option key={o.id} value={o.id}>
                                                                    {o.code} - {o.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Member Entity Type */}
                                                    <div className="mt-3">
                                                        <div>Entity Type</div>
                                                        <select
                                                            className="form-select"
                                                            name="entityTypeId"
                                                            value={values.entityTypeId}
                                                            onChange={(e: any) => {
                                                                handleChange(e);
                                                                // immediate reset (UX improvement)
                                                                setFieldValue("memberId", "");
                                                            }}
                                                        >
                                                            <option value="">Select Type</option>
                                                            {allEntityTypeData?.map((t: any) => (
                                                                <option key={t.id} value={t.id}>
                                                                    {t.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Member */}
                                                    <div className="mt-3">
                                                        <div>Entity</div>
                                                        <select
                                                            className="form-select"
                                                            name="memberId"
                                                            value={values.memberId}
                                                            onChange={handleChange}
                                                            disabled={!values.entityTypeId}

                                                        >
                                                            <option value="">Select Entity</option>
                                                            {allEntityMasterData?.
                                                                filter(
                                                                    (e: any) =>
                                                                        e.entityType?.id === Number(values.entityTypeId)
                                                                )
                                                                .map((e: any) => (
                                                                    <option key={e.id} value={e.id}>
                                                                        {e.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>

                                                    {/* Interviewer Entity Type */}
                                                    <div className="mt-3">
                                                        <div>Interviewer Entity Type</div>
                                                        <select
                                                            className="form-select"
                                                            name="entityTypeInterviewerId"
                                                            value={values.entityTypeInterviewerId}
                                                            onChange={(e: any) => {
                                                                handleChange(e);
                                                                // immediate reset (UX improvement)
                                                                setFieldValue("interviewedById", "");
                                                            }}
                                                        >
                                                            <option value="">Select Type</option>
                                                            {allEntityTypeData?.map((t: any) => (
                                                                <option key={t.id} value={t.id}>
                                                                    {t.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    {/* Interviewed By */}
                                                    <div className="mt-3">
                                                        <div>Interviewed By</div>
                                                        <select
                                                            className="form-select"
                                                            name="interviewedById"
                                                            value={values.interviewedById}
                                                            onChange={handleChange}
                                                            disabled={!values.entityTypeInterviewerId}
                                                        >
                                                            <option value="">Select Interviewer</option>
                                                            {allEntityMasterData?.
                                                                filter(
                                                                    (e: any) =>
                                                                        e.entityType?.id === Number(values.entityTypeInterviewerId)
                                                                )
                                                                .map((e: any) => (
                                                                    <option key={e.id} value={e.id}>
                                                                        {e.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>

                                                    {/* Interview Date */}
                                                    <div className="mt-3">
                                                        <div>Interview Date</div>
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm w-50"
                                                            name="interviewDate"
                                                            value={
                                                                values.interviewDate
                                                                    ? format(parseISO(values.interviewDate), "yyyy-MM-dd")
                                                                    : ""
                                                            }
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Interview Type */}
                                                    <div className="mt-3">
                                                        <div>Interview Type</div>
                                                        <select
                                                            className="form-select"
                                                            name="interviewType"
                                                            value={values.interviewType}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Type</option>
                                                            <option value="Online">Online</option>
                                                            <option value="Offline">Offline</option>
                                                            <option value="Panel">Panel</option>
                                                        </select>
                                                    </div>

                                                    {/* Interview Score */}
                                                    <div className="mt-3">
                                                        <div>Interview Score</div>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="interviewScore"
                                                            value={values.interviewScore}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Interview Assessment */}
                                                    <div className="mt-3">
                                                        <div>Interview Assessment</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="interviewAssessment"
                                                            value={values.interviewAssessment}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Panel Decision */}
                                                    <div className="mt-3">
                                                        <div>Panel Decision</div>
                                                        <select
                                                            className="form-select"
                                                            name="panelDecision"
                                                            value={values.panelDecision}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Approved">Approved</option>
                                                            <option value="Rejected">Rejected</option>
                                                            <option value="Hold">Hold</option>
                                                        </select>
                                                    </div>

                                                    {/* Panel Remarks */}
                                                    <div className="mt-3">
                                                        <div>Remarks From Panel</div>
                                                        <textarea
                                                            className="form-control"
                                                            name="remarksFromPanel"
                                                            value={values.remarksFromPanel}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Interview Video Link */}
                                                    <div className="mt-3">
                                                        <div>Interview Video Link</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="interviewVideoLink"
                                                            value={values.interviewVideoLink}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* <div className="mt-3">
                                                        <div>Opportunity Code</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="opportunityCode"
                                                            value={values.opportunityCode}
                                                            onChange={handleChange}
                                                        />
                                                    </div> */}

                                                    <div className="mt-3">
                                                        <div>Finance Transaction Code</div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="financeTransactionCode"
                                                            value={values.financeTransactionCode}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Organization Entity */}
                                                    <div className="mt-3">
                                                        <div>Organization Entity</div>
                                                        <select
                                                            className="form-select"
                                                            name="entityId"
                                                            value={values.entityId}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Entity</option>
                                                            {allEntityMasterData?.map((e: any) => (
                                                                <option key={e.id} value={e.id}>
                                                                    {e.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* File Upload */}
                                                    <div className="mt-3">
                                                        <div>File Upload</div>
                                                        <div className="d-flex">
                                                            <input
                                                                type="file"
                                                                hidden
                                                                id="fileUpload"
                                                                onChange={(e: any) => {
                                                                    fileHandler(e, "file");
                                                                    setFieldValue("file", e.target.files[0]);
                                                                }}
                                                            />
                                                            <label htmlFor="fileUpload" className="btn btn-primary mx-2  mt-3" style={{ width: "30%" }}>Upload file</label>
                                                            <p className="mt-4">{fileName}</p>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                        </>
                                        < div className="d-flex flex-row justify-content-center">
                                            <button
                                                type="submit"
                                                className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                            >
                                                {props.actionType === ACTION_TYPE.ADD_ACTION
                                                    ? "Save"
                                                    : "Update"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                                onClick={handleClose}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </Form>
                                )
                            }}
                        </Formik>
                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                // href={`/templates/${props.reportName === REPORT_NAME.VALUE_CHAIN ? 'VALUE_CHAIN'
                                //     : props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ? 'VALUE_CHAIN_CATEGORY'
                                //         : props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ? 'RESPONSIBILITY_GROUP'
                                //             : props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ? 'RESPONSIBILITY_CENTER'
                                //                 : props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER ? 'TOKEN_MECHANISM_MASTER'
                                //                     : ''}.xlsx`}

                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}

                </Modal.Body >
            </Modal >
        </>
    );

};

export default OpportunityData;